import { Injectable, ElementRef } from '@angular/core';
import * as _ from 'lodash';
// Components
import { ModalComponent } from 'shared/components/modal/modal.component';
import { ModalLightboxComponent } from 'shared/components/modal-lightbox/modal-lightbox.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  public modals = new Array<ModalComponent | ModalLightboxComponent>();

  add(modal: any): void {
    this.modals.push(modal);
  }

  remove(id: string): void {
    const modalToRemove = _.find(this.modals, { id: id });
    this.modals = _.without(this.modals, modalToRemove);
  }

  open(id: string, data?: any): void {
    const modal = _.find(this.modals, { id: id });
    modal.open(data);
  }

  close(id: string): void {
    const modal = _.find(this.modals, { id: id });
    modal.close();
  }

  show(id: string, data?: any): void {
    const modal = _.find(this.modals, { id: id });
    modal.show();
  }

  hide(id: string): void {
    const modal = _.find(this.modals, { id: id });
    modal.hide();
  }

  getContent(id: string): ElementRef {
    const modal = _.find(this.modals, { id: id });
    return modal.modalContent;
  }
}
